"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var Event = /** @class */ (function () {
    function Event(name, type, source, priority) {
        this.name = name;
        this.type = type;
        this.priority = priority ? priority : constants_1.Priority.NORMAL;
        this.source = source;
        this.counters = {};
        this.timers = {};
        this.metrics = {};
    }
    /**
     * Adds a counter metric to the event.
     *
     * @param {string} name
     * @param {number} count
     * @returns {IEvent}
     */
    Event.prototype.addCounter = function (name, count) {
        return this.incrementCounter(name, count);
    };
    /**
     * Adds Data to the event.
     *
     * @param {string} name
     * @param {string} value
     * @returns {IEvent}
     */
    Event.prototype.addData = function (name, value) {
        this.data[name] = value;
        return this;
    };
    /**
     * Adds a custom metric to the event.
     *
     * @param {string} name
     * @param {string | number | boolean} value
     * @returns {IEvent}
     */
    Event.prototype.addMetric = function (name, value) {
        this.metrics[name] = value;
        return this;
    };
    /**
     * Adds a Timer metric to the event with the time value provided.
     *
     * @param {string} name
     * @param {number} duration
     * @returns {IEvent}
     */
    Event.prototype.addTimer = function (name, duration) {
        return this.incrementTimer(name, duration);
    };
    /**
     * Creates an event data object and returns it.
     * TODO: Deepcopy? as react will freeze the data when they are sent to the bridge,
     * or should we not care about an event after its recorded ?
     *
     * @returns {IEventData}
     */
    Event.prototype.getEventData = function () {
        return {
            counters: this.counters,
            data: this.data,
            metrics: this.metrics,
            name: this.name,
            priority: constants_1.Priority[this.priority],
            source: this.source,
            timers: this.timers,
            eventType: this.type,
        };
    };
    /**
     * Increments the counter metric with 1 as default value if not provided. If
     * a counter doesn't exist it would be created.
     *
     * @param {string} name
     * @param {number} incrementBy
     * @returns {IEvent}
     */
    Event.prototype.incrementCounter = function (name, incrementBy) {
        var incrementByValue = incrementBy !== undefined && incrementBy !== null ? incrementBy : 1;
        var value = this.counters[name];
        if (!value) {
            value = 0;
        }
        value += incrementByValue;
        this.counters[name] = value;
        return this;
    };
    /**
     * Increments Timer metric with the provided value. If the timer doesn't exist
     * then it would be created.
     *
     * @param {string} name
     * @param {number} time
     * @returns {IEvent}
     */
    Event.prototype.incrementTimer = function (name, time) {
        var finalValue = this.timers[name];
        if (!finalValue) {
            finalValue = 0;
        }
        finalValue = finalValue ? finalValue + time : time;
        this.timers[name] = finalValue;
        return this;
    };
    /**
     * Removes the counter.
     *
     * @param {string} name
     * @returns {IEvent}
     */
    Event.prototype.removeCounter = function (name) {
        delete this.counters[name];
        return this;
    };
    /**
     * Removes the data.
     *
     * @param name
     */
    Event.prototype.removeData = function (name) {
        delete this.data[name];
        return this;
    };
    /**
     * Removes the Metric.
     *
     * @param {string} name
     * @returns {IEvent}
     */
    Event.prototype.removeMetric = function (name) {
        delete this.metrics[name];
        return this;
    };
    /**
     * Removes the timer.
     *
     * @param {string} name
     * @returns {IEvent}
     */
    Event.prototype.removeTimer = function (name) {
        delete this.timers[name];
        return this;
    };
    return Event;
}());
exports.Event = Event;
//# sourceMappingURL=event.js.map